import { getObjectKeysAsObject } from "@checkout/helpers";
import { fetchPriceFreezeService } from "./fetchPriceFreeze";

export const services = {
  fetchPriceFreezeService,
};

export const ServiceTypes = getObjectKeysAsObject(services);
